import React from "react";
import {useTranslation} from "react-i18next";
import Header from "./Header";
import PoweredBy from "./PoweredBy";
import {VerificationIcon} from "../icons/VerificationIcon";

function VerificationInProgress() {
    const {t} = useTranslation();
    return (
        <div className="flex flex-col gap-4 w-full h-full">
            <Header/>
            <div className="flex flex-col gap-4 w-full p-4  h-full justify-between">
                <div className="flex flex-col items-center justify-center gap-4 mt-10">
                    <VerificationIcon/>
                    <div className="mb-5 text-center">
                        <div className="font-normal text-xl" style={{color: "var(--urtentic-sdk-title, #000000)"}}>{t("common.verificationInProgress.heading")}</div>
                        <div className="text-sm pr-7 pl-7 pt-2" style={{color: "var(--urtentic-sdk-subtitle, #737373)"}}>
                            {t("common.verificationInProgress.desc")}
                        </div>
                    </div>
                </div>
                <div className="flex flex-col items-center">
                    <div className="flex-row flex justify-center mt-3">
                        <PoweredBy/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VerificationInProgress;
